module.exports = __webpack_public_path__ + "img/fencejunction2.fce4cd09.webp";